<template>
  <div class="logo">
    <h1 class="logo__headline">KVH Tabu</h1>
    <p class="logo__subline">
      Ein kleines, Tabu-ähnliches Spiel für den Browser
    </p>
  </div>
</template>

<script>
  export default {
    name: 'Logo'
  };
</script>
